const { OverlayScrollbars, ClickScrollPlugin } = OverlayScrollbarsGlobal;
OverlayScrollbars.plugin(ClickScrollPlugin);
function personGallery() {

    if ( $('.person-gallery').length ) {

        $('.person-gallery__inner a.btn').click(function(e) {
            e.preventDefault();
            const $this = $(this),
                  $cont = $this.closest('.gallery-item__cont'),
                  personName = $('h4', $cont).text(),
                  personTitle = $('.person-title', $cont).text(),
                  personImage = $('.gallery-item__image img', $cont).attr('src'),
                  personImageFull = $cont.attr('data-image'),
                  bioHTML = $('.person-bio', $cont).html();

            const modalHTML = `
                <div class="bio-modal">
                    <div class="bio-modal__left">
                        <img src="${personImage}" alt="${personName}" />
                        <a class="download-headshot" href="${personImageFull}" target="_blank" download>Download Headshot</a>
                    </div>
                    <div class="bio-modal__right">
                        <h2 class="heading-5">${personName}</h2>
                        <h3 class="heading-7">${personTitle}</h3>
                        <div class="bio-modal__copy">${bioHTML}</div>
                    </div>
                </div>
            `
            $('.modal-window__target').html(modalHTML);

            // Custom scrollbar for modal overflow
            if (window.matchMedia('(max-width: 767px)').matches) {
                OverlayScrollbars(document.querySelector('.bio-modal__right'), {
                    scrollbars: {
                        clickScroll: true,
                    },
                });
            } else {
                OverlayScrollbars(document.querySelector('.bio-modal__copy'), {
                    scrollbars: {
                        clickScroll: true,
                    },
                });
            }
            openModal();
        });

        $('a.download-headshot').click(function(e) {
            e.preventDefault();
        });

        let url = window.location.href,
			selPerson = getURLParameter(url, 'person');

        if (selPerson) {
            console.log($('[data-name*="'+selPerson+'"]'));
            $('[data-name*="'+selPerson+'"] a').trigger('click');
        }

    }

}
